function reviews(){
	var $parent = $('.reviews'),
			$elem = $parent.find('.reviews-block');

	var mobileReviews = function(){
		if ($(window).outerWidth() < 992) {
			$elem.not($elem[0]).hide();
		}else{
			$elem.show();
		}
	}
	mobileReviews();

	$(window).resize(function(){
		mobileReviews();
	})
}
reviews();